<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="isEditMode">{{ $t("country.name") }} "{{ editedEntity.name | translate }}" {{ $t("common.update") }}</span>
        <span v-else>{{ $t("country.country-safe-mapping.new") }}</span>
      </h2>
      <label class="mt-2">{{ $t("country.name") }}</label>
      {{ form.name }}
      <filter-select
        id="countryFilter"
        ref="countryFilter"
        :placeholder="$t('country.select')"
        :multiple="false"
        :selected="selectedCountry"
        @filter="onCountrySearch"
        @changed="onCountrySelect"
        track="code"
      />

      <label class="mt-2">{{ $t("country.country-safe-mapping.name") }}</label>
      <filter-select
        id="countriesFilter"
        ref="countriesFilter"
        :placeholder="$t('country.select')"
        :multiple="true"
        @filter="onCountriesSearch"
        :selected="form.countries"
        @changed="onCountriesSelect"
        track="code"
      />
      <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import Countries from "../countries/countries.json";
const state = "workspaceSafeCountryMap";

export default {
  components: {},
  data() {
    return {
      form: {
        countries: [],
        country: undefined,
      },
      formError: undefined,
    };
  },
  validations: {
    form: {
      countries: {
        required,
      },
      country: {
        required,
      },
    },
  },

  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${state}/isEditMode`];
    },
    selectedCountry() {
      return Countries.find((c) => c.name[this.currentLanguage] === this.form.name);
    },
  },
  mounted() {},
  methods: {
    customLabel(value) {
      return this.$options.filters.translate(value.name);
    },
    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch(`${state}/save`, { _id: this.form._id, name: this.form.country.name, code: this.form.country.code, countries: this.form.countries });
        this.form = {};
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    rightPanelClosed() {
      this.$refs.categoryFilter.reset();
    },

    async onCountrySearch(value, callback) {
      const lang = "tr";
      const response = Countries.filter((x) => x.name[lang].toLowerCase().includes(value.toLowerCase()));
      callback(response);
    },
    onCountrySelect(item) {
      this.form = { ...this.form, country: item };
    },
    async onCountriesSearch(value, callback) {
      const lang = "tr";
      const response = Countries.filter((x) => x.name[lang].toLowerCase().includes(value.toLowerCase()));
      callback(response);
    },
    onCountriesSelect(item) {
      this.form = { ...this.form, countries: item };
    },
  },
};
</script>
